import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';

// Updated imports for app-specific pages
import DateCalcPrivacyPolicyPage from './pages/apps/date-calculator/PrivacyPolicyPage';
import DateCalcTermsPage from './pages/apps/date-calculator/TermsPage';
import RngTermsPage from './pages/apps/random-number-generator/TermsPage';
import RngPrivacyPolicyPage from './pages/apps/random-number-generator/PrivacyPolicyPage';
import CollectXTermsPage from './pages/apps/collectx/TermsPage';
import CollectXPrivacyPolicyPage from './pages/apps/collectx/PrivacyPolicyPage';
import NoteAndToDoTermsPage from './pages/apps/note-and-to-do/TermsPage';
import NoteAndToDoPrivacyPolicyPage from './pages/apps/note-and-to-do/PrivacyPolicyPage';

// Imports for new general pages
import WebsiteTermsPage from './pages/WebsiteTermsPage';
import WebsitePrivacyPolicyPage from './pages/WebsitePrivacyPolicyPage';
import AboutUsPage from './pages/AboutUsPage';

function App() {
  return (
    <Router>
      <div className="app-container">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            
            {/* App Routes */}
            <Route 
              path="/apps/date-calculator/privacy-policy" 
              element={<DateCalcPrivacyPolicyPage />} 
            />
            <Route 
              path="/apps/date-calculator/terms-of-service" 
              element={<DateCalcTermsPage />} 
            />
            <Route 
              path="/apps/random-number-generator/terms-of-service" 
              element={<RngTermsPage />} 
            />
            <Route 
              path="/apps/random-number-generator/privacy-policy" 
              element={<RngPrivacyPolicyPage />} 
            />
            <Route 
              path="/apps/collectx/terms-of-service" 
              element={<CollectXTermsPage />} 
            />
            <Route 
              path="/apps/collectx/privacy-policy" 
              element={<CollectXPrivacyPolicyPage />} 
            />
            <Route 
              path="/apps/note-and-to-do/terms-of-service" 
              element={<NoteAndToDoTermsPage />} 
            />
            <Route 
              path="/apps/note-and-to-do/privacy-policy" 
              element={<NoteAndToDoPrivacyPolicyPage />} 
            />
            
            {/* General Website Routes */}
            <Route path="/terms-of-service" element={<WebsiteTermsPage />} />
            <Route path="/privacy-policy" element={<WebsitePrivacyPolicyPage />} />
            <Route path="/about-us" element={<AboutUsPage />} />

            {/* Add other general routes here if needed */}
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;